import { type FC } from 'react';
import { TLengthStyledSystem } from 'styled-system';

import { Box } from '../Box';
import { progressStyles } from './ProgressBar.styles';

export type ProgressBarProps = {
  /**
   * Progress value between 0 and 100
   */
  progress: number;
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Height of the progress bar
   */
  height?: TLengthStyledSystem;
  /**
   * Kind of the progress bar
   */
  kind?: 'rounded' | 'square';
};

const ProgressBar: FC<ProgressBarProps> = ({
  progress,
  className,
  kind = 'rounded',
  height = '10px',
}) => {
  // Clamp progress between 0 and 100
  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
    <Box
      width="100%"
      height={height}
      backgroundColor="var(--color-primary-100)"
      borderRadius={kind === 'rounded' ? '48px' : '0px'}
      overflow="hidden"
      position="relative"
      className={className}
    >
      <Box
        height="100%"
        borderRadius={kind === 'rounded' ? '48px' : '0px'}
        backgroundColor="var(--color-primary-900)"
        css={progressStyles}
        style={{ width: `${clampedProgress}%` }}
        role="progressbar"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </Box>
  );
};

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
